export const GET_ACCOUNT_ITEM_RATES = 'GET_ACCOUNT_ITEM_RATES';
export const ACCOUNT_ITEM_RATE_REQUEST = 'ACCOUNT_ITEM_RATE_REQUEST';
export const CREATE_ACCOUNT_ITEM_RATE = 'CREATE_ACCOUNT_ITEM_RATE';
export const UPDATE_ACCOUNT_ITEM_RATE = 'UPDATE_ACCOUNT_ITEM_RATE';
export const ACCOUNT_ITEM_RATE_REQUEST_FAILURE = 'ACCOUNT_ITEM_RATE_REQUEST_FAILURE';
